import { createUpdateTourStatusValidator } from "#validators/tour.validator.factory";
// Use factory function with pass-through translation for type inference
const updateTourStatusValidatorForType = createUpdateTourStatusValidator((key) => key);
